import Recommendations from './containers/Recommendations';

export default Recommendations;
